"use client"

import { useEffect } from 'react';
import * as gtm from '@/lib/gtm';
import { usePathname } from 'next/navigation';

function PageTracker() {
  const pathname = usePathname();

  useEffect(() => {
    gtm.pageView(pathname);
  }, [pathname]);

  return null;
}

export default PageTracker;